module.exports = __webpack_public_path__ + "img/canada-liver-cancer-male.56e14082.png";